import CreditNoteDetailsContainer from "@legacy/credit_notes/CreditNoteDetailsContainer"

import useToastQueue from "@hooks/useToastQueue"

import { AppFrame } from "@templates"

export default function CreditNotePublicDetails() {
    const { addToastToQueue } = useToastQueue()
    return (
        <AppFrame.Root pageId="CreditNotePublicDetails" navigationType="none">
            <AppFrame.PageContent>
                <CreditNoteDetailsContainer addToastToQueue={addToastToQueue} />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
